import { render } from "./DiscountInfoTable.vue?vue&type=template&id=8a297efe&scoped=true"
import script from "./DiscountInfoTable.vue?vue&type=script&lang=js"
export * from "./DiscountInfoTable.vue?vue&type=script&lang=js"

import "./DiscountInfoTable.vue?vue&type=style&index=0&id=8a297efe&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a297efe"]])

export default __exports__